"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staffApi = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
var staffApi = exports.staffApi = {
  findAll: function findAll(params) {
    return (0, _request.default)({
      url: "/staff",
      params: params
    });
  },
  create: function create(data) {
    return (0, _request.default)({
      url: "/staff",
      data: data,
      method: "post"
    });
  },
  update: function update(id, data) {
    return (0, _request.default)({
      url: "/staff/".concat(id, "/update"),
      data: data,
      method: "post"
    });
  },
  remove: function remove(id) {
    return (0, _request.default)({
      url: "/staff/".concat(id, "/delete"),
      method: "post"
    });
  }
};